module.exports = __webpack_public_path__ + "assets/img/2606.ab24ad0d.svg";